export default {
    computed: {
        new_mode () {
            return this.show_lpd
        },
        show_rs () {
            return this.checkStatus('lfd')
        },
        show_reg () {
            return this.checkStatus('lrd')
        },
        show_lpd () {
            return this.checkStatus('lpd')
        },
        show_result_btn () {
            return ['show_reg', 'show_rs', 'show_lpd'].some(key => this[key])
        }
    },
    methods: {
        checkStatus (type) {
            if (this.is_selling) {
                return false
            }
            return this.current_house[`${type}_status`] === `${type}_completed`
        },
        navigateToResult (type) {
            wx.navigateTo({
                url: `/result/main?house_id=${this.current_house.id}&building_id=${this.house.id}&name=${this.house.name}&type=${type}`
            })
        },
        goReg () {
            wx.navigateTo({
                url: `/building/result/main?house_id=${this.current_house.id}&building_id=${this.house.id}&name=${this.house.name}&type=bulletin`
            })
        },
        goResult () {
            wx.navigateTo({
                url: `/building/result/main?house_id=${this.current_house.id}&building_id=${this.house.id}&name=${this.house.name}&type=publicity`
            })
        }
    }
}